import type {UserAccountFlags} from '@frontend/types/GlobalStores'
import {create} from 'zustand/react'

// Тип состояния хранилища.
export interface AccountFlagsStoreType {
    // Данные:

    // Создавал ли пользователь объявления?
    isSeller: boolean
    // Есть ли новые уведомления?
    hasNewNotifications: boolean
    // Есть ли новые сообщения?
    hasNewChatMessages: boolean
    // Есть ли новые ответы от службы поддержки?
    hasNewSupportTicketReplies: boolean

    // API:

    // Задать флаги-счетчики для элементов бокового меню.
    setFlags: (this: void, flags: UserAccountFlags) => void

    // Изменить состояние флага наличия новых уведомлений.
    setHasNewNotifications: (this: void, value: boolean) => void

    // Изменить состояние флага наличия новых сообщений в чате.
    setHasNewChatMessages: (this: void, value: boolean) => void

    // Изменить состояние флага наличия новых ответов от службы поддержки.
    setHasNewSupportTicketReplies: (this: void, value: boolean) => void

    // Изменить состояние флага наличия объявлений у пользователя.
    setIsSeller(this: void, value: boolean): void
}

// Хранилище состояния флагов для аккаунта пользователя.
export const useAccountFlagsStore = create<AccountFlagsStoreType>(
    set => ({
        isSeller: false,
        hasNewNotifications: false,
        hasNewChatMessages: false,
        hasNewSupportTicketReplies: false,

        // API:

        setFlags(flags: UserAccountFlags): void {
            set({
                isSeller: flags.isSeller,
                hasNewNotifications: flags.newNotifications,
                hasNewChatMessages: flags.newChatMessages,
                hasNewSupportTicketReplies: flags.newSupportTicketReplies,
            })
        },

        setHasNewNotifications(value: boolean): void {
            set({
                hasNewNotifications: value,
            })
        },

        setHasNewChatMessages(value: boolean): void {
            set({
                hasNewChatMessages: value,
            })
        },

        setHasNewSupportTicketReplies(value: boolean): void {
            set({
                hasNewSupportTicketReplies: value,
            })
        },

        setIsSeller(value: boolean): void {
            set({
                isSeller: value,
            })
        },
    })
)
